const dashboardItem = {
  orderItem: {
    unitPrice: 'Einzelpreis',
    quantity: 'Stück',
    total: 'Summe',
  },
  orderItemPrescription: {
    prescription: 'Rezept',
    ePrescription: 'E-Rezept',
    preOrder: 'Rezeptpflichtige Vorbestellung. Eine Nachbestellung ist nur bei Vorlage eines neuen Rezepts möglich.',
    toPrescriptionUpload: '(E-)Rezept-Upload',
    ePrescriptionDescriptionSingular: 'E-Rezept mit {count} Medikament',
    ePrescriptionDescriptionPlural: 'E-Rezept mit {count} Medikamenten',
  },
  dashboardItem: {
    reorder: 'Nachbestellen',
    subtotal: 'Zwischensumme',
    delivery: 'Botendienst',
    coupon: 'Coupon',
    total: 'Gesamtsumme',
    vat: '(inkl. MwSt.)',
    contactPharmacy: 'Bitte kontaktieren Sie Ihre Apotheke, um Ihre',
    cancelOrder: 'Bestellung zu stornieren',
    orderReady: 'Bestellung bereit',
    orderCompleted: 'Abgeschlossen',
    orderInProgress: 'Bestellung in Bearbeitung',
    orderCanceled: 'Storniert',
    orderPending: 'Bestellung Offen',
    inTotal: 'Gesamt',
    order: 'Bestellung',
    pharmacy: 'Apotheke',
    products: 'Produkte',
    orderStatus: 'Bestellstatus',
    coPayments: 'Über die Höhe von Zuzahlungen informiert Sie Ihre Apotheke.',
    yourMessage: 'Ihre Nachricht:',
    allOrders: 'Alle Bestellungen',
    action: 'Aktion',
    unavailableProduct: 'Die PZN { pzn } ist nicht mehr verfügbar',
    prescriptionNote: '* Bei Vorbestellungen, die ein Rezept enthalten, kann der Betrag für die Zuzahlung sowie der durch den privat versicherten Patienten zu bezahlende Arzneimittelpreis, erst nach Abschluss der Vorbestellung durch den Apotheker final ermittelt und mitgeteilt werden. Daher ist der hier ausgegebene Betrag in diesem Fall eine vorläufige Preisinformation.',
  },

}

export default dashboardItem
